import { Box, Stack, Typography, Divider } from '@mui/material';
import colors from '@styles/colors.module.scss';
import { VacancyControllerGetStatisticsApiResponse } from '@api/admin/adminGeneratedApi';
import styles from './styles.module.scss';

export interface VacancyStatisticsProps {
  data: VacancyControllerGetStatisticsApiResponse;
}

const fieldOptions: {
  field: Partial<keyof VacancyControllerGetStatisticsApiResponse | string>;
  title: string;
  formatter?: (value: any, record: VacancyControllerGetStatisticsApiResponse) => React.ReactNode;
}[] = [
  // --- Просмотры вакансии ---
  { field: 'viewsCount', title: 'Количество просмотров вакансии' },
  { field: 'uniqueViewersCount', title: 'Количество уникальных пользователей' },
  { field: 'favoritesCount', title: 'Количество вакансий, добавленных в избранное' },
  { field: 'responsesCount', title: 'Количество кликов по «Откликнуться»:' },
];

export const VacancyStatistics = ({ data }: VacancyStatisticsProps) => {
  return (
    <Stack divider={<Divider className={styles.divider} />}>
      {fieldOptions.map(({ field, title, formatter }) => {
        const dataValue = data[field as keyof VacancyControllerGetStatisticsApiResponse];
        const value =
          dataValue !== undefined ? (formatter ? formatter(dataValue, data) : (dataValue as any)) : 'Не указан';

        return (
          <Box key={field as string} className={styles.row}>
            <Typography
              className={styles.rowTitle}
              onClick={() => {
                if (typeof value !== 'string') return;
                navigator.clipboard.writeText(value.trim());
              }}>
              {title}:
            </Typography>
            <Typography variant="body2" color={dataValue ? colors.black : colors.grey}>
              {value}
            </Typography>
          </Box>
        );
      })}
    </Stack>
  );
};
